if (!customElements.get('length-stepper')) {
  // Select Meter label + box: border, text, + / - icons ka black color -> #1A589A (label bold)
  if (!document.getElementById('length-stepper-color')) {
    const colorStyle = document.createElement('style');
    colorStyle.id = 'length-stepper-color';
    colorStyle.textContent =
      '.product-form__quantity .quantity__label,.product-form__quantity .quantity__label span{color:#1A589A;font-weight:700;}' +
      'length-stepper.quantity{--color-foreground:26,88,154;color:#1A589A;}' +
      'length-stepper.quantity:after{box-shadow:0 0 0 var(--inputs-border-width) #1A589A;}' +
      'length-stepper.quantity:before{box-shadow:none;}' +
      'length-stepper.quantity .quantity__input{color:#1A589A;-webkit-text-fill-color:#1A589A;opacity:1;}' +
      'length-stepper.quantity .quantity__button{color:#1A589A;}' +
      'length-stepper.quantity .quantity__button svg,length-stepper.quantity .quantity__button .icon{color:#1A589A;fill:#1A589A;}' +
      'length-stepper.quantity .quantity__button path{fill:#1A589A;stroke:#1A589A;}';
    document.head.appendChild(colorStyle);
  }

  customElements.define(
    'length-stepper',
    class LengthStepper extends HTMLElement {
      constructor() {
        super();
        this.display = this.querySelector('.quantity__input');
        this.minusButton = this.querySelector(".quantity__button[name='minus']");
        this.plusButton = this.querySelector(".quantity__button[name='plus']");
        this.realQuantityInput = this.parentElement.querySelector('[data-meter-real-quantity]');

        this.min = parseInt(this.dataset.min, 10) || 4;
        this.max = parseInt(this.dataset.max, 10) || 80;
        this.step = parseInt(this.dataset.step, 10) || 1;
        this.unit = parseFloat(this.dataset.unit) || 0.25;

        this.minusButton.addEventListener('click', this.onButtonClick.bind(this));
        this.plusButton.addEventListener('click', this.onButtonClick.bind(this));

        this.onPageShow = this.onPageShow.bind(this);
        this.onVisible = this.onVisible.bind(this);
      }

      connectedCallback() {
        this.refreshDisplay();

        // Cart se wapas aane par (back / bfcache / tab switch) stepper ko cart ke saath sync rakho
        window.addEventListener('pageshow', this.onPageShow);
        document.addEventListener('visibilitychange', this.onVisible);

        // Cart drawer me meter badalne par bhi sync ho
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
            this.syncWithCart();
          });
        }

        this.syncWithCart();
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('visibilitychange', this.onVisible);
        if (this.cartUnsubscriber) this.cartUnsubscriber();
      }

      onPageShow(event) {
        if (event.persisted) this.syncWithCart();
      }

      onVisible() {
        if (document.visibilityState === 'visible') this.syncWithCart();
      }

      getVariantId() {
        const form = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
        const idInput = form ? form.querySelector('[name="id"]') : null;
        return idInput ? String(idInput.value) : null;
      }

      syncWithCart() {
        const variantId = this.getVariantId();
        if (!variantId) return;

        fetch(`${window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'}cart.js`, {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        })
          .then((response) => response.json())
          .then((cart) => {
            const item = (cart.items || []).find((line) => String(line.variant_id) === variantId);
            const target = item ? item.quantity : this.min;
            const clamped = Math.min(Math.max(target, this.min), this.max);
            if (clamped === this.getCurrentQuantity()) {
              this.refreshDisplay();
              return;
            }
            this.realQuantityInput.value = clamped;
            this.realQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            this.refreshDisplay();
          })
          .catch(() => {});
      }

      getCurrentQuantity() {
        const value = parseInt(this.realQuantityInput.value, 10);
        return Number.isFinite(value) ? value : this.min;
      }

      formatMeters(quantity) {
        return String(quantity * this.unit);
      }

      updateButtonStates(quantity) {
        this.minusButton.classList.toggle('disabled', quantity <= this.min);
        this.plusButton.classList.toggle('disabled', quantity >= this.max);
      }

      refreshDisplay() {
        const quantity = this.getCurrentQuantity();
        this.display.value = this.formatMeters(quantity);
        this.updateButtonStates(quantity);
      }

      onButtonClick(event) {
        event.preventDefault();
        if (event.currentTarget.classList.contains('disabled')) return;

        const current = this.getCurrentQuantity();
        const goingUp = event.currentTarget.name === 'plus';
        const next = goingUp
          ? Math.min(current + this.step, this.max)
          : Math.max(current - this.step, this.min);

        if (next === current) return;

        this.realQuantityInput.value = next;
        this.realQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.display.value = this.formatMeters(next);
        this.updateButtonStates(next);
      }
    }
  );
}
